/**
 * Form validation and submission enhancements
 * Uses Bootstrap 5's built-in validation classes
 */

export function initForms() {
  // Bootstrap validation — prevent submit on invalid
  document.querySelectorAll('.needs-validation').forEach(form => {
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
      }
      // Anti-spam honeypot: if filled, abort silently
      const hp = form.querySelector('[name$="[_hp]"]');
      if (hp && hp.value.trim() !== '') {
        event.preventDefault();
        return;
      }
      form.classList.add('was-validated');
    }, false);
  });

  // Character counter for textareas
  document.querySelectorAll('textarea[data-max-chars]').forEach(ta => {
    const max = parseInt(ta.dataset.maxChars, 10);
    const counter = document.createElement('small');
    counter.className = 'form-text text-muted d-block text-end mt-1';
    counter.textContent = `0 / ${max}`;
    ta.after(counter);

    ta.addEventListener('input', () => {
      const len = ta.value.length;
      counter.textContent = `${len} / ${max}`;
      counter.classList.toggle('text-danger', len > max);
    });
  });

  // Floating labels: move label when field has value on load
  document.querySelectorAll('.form-floating input, .form-floating textarea').forEach(el => {
    if (el.value) el.dispatchEvent(new Event('input'));
  });
}
